import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  IconButton,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  LinearProgress,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { ExpandMore, Refresh } from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { creators as errorCreators } from '~/ducks/error';
import getReauthCreditCard from '~/services/users/getReauthCreditCard';
import sendEmailCreditCard from '~/services/users/sendEmailCreditCard';
import '../style.css';

class ReauthCreditCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      creditCard: [],
      capital: false,
      roundupsEnabled: true,
      expanded: true,
    };
  }

  async componentDidMount() {
    if (this.state.fetching) {
      await this.refreshUsersCreditCard(false);
    }
  }

  handleChange() {
    this.setState({ expanded: !this.state.expanded });
  }

  async refreshUsersCreditCard(event) {
    if (event) {
      event.stopPropagation();
    }
    if (!this.state.fetching) {
      this.setState({
        fetching: true,
      });
    }
    const response = await getReauthCreditCard(this.state.capital, this.state.roundupsEnabled);
    if (response.error) {
      this.props.dispatch(
        errorCreators.new({
          message: 'Failed to fetch users who needs their credit card re-authed',
          action: false,
        }),
      );
      this.setState({
        fetching: false,
        creditCard: [],
      });
    } else {
      this.setState({
        creditCard: response.data,
        fetching: false,
      });
    }
  }
  async sendEmailToAllUsersForCreditCard(event) {
    event.stopPropagation();
    const response = await sendEmailCreditCard(this.state.capital, this.state.roundupsEnabled);
    if (response.error) {
      this.props.dispatch(
        errorCreators.new({
          message: 'Failed to send email to all users',
          action: false,
        }),
      );
    } else {
      await this.refreshUsersCreditCard(false);
    }
  }

  render() {
    return (
      <Paper square style={{ height: '50%' }}>
        <Accordion square expanded={this.state.expanded} onChange={() => this.handleChange()}>
          <AccordionSummary
            expandIcon={
              <Tooltip title={this.state.expanded ? 'Collapse' : 'Expand'}>
                <ExpandMore style={{ color: 'white' }} />
              </Tooltip>
            }
            aria-controls="panel1c-content"
            id="panel1c-header"
            style={{ color: 'white', backgroundColor: '#3f51b5', minHeight: 48 }}
            classes={{ content: 'accordion-summary-content' }}
          >
            <Typography variant="h6" color="inherit" className="flex-grow">
              {`Credit Card - Total: ${this.state.creditCard.length}`}
            </Typography>
            <Tooltip title={'Send email'} onClick={(event) => this.sendEmailToAllUsersForCreditCard(event)}>
              <Button
                size="small"
                variant="outlined"
                style={{ color: 'white', borderColor: 'white', marginRight: '10px' }}
              >
                Send Email To All
              </Button>
            </Tooltip>
            <Tooltip
              title="Refresh Users who needs their credit card to be re-authed"
              onClick={(event) => this.refreshUsersCreditCard(event)}
            >
              <IconButton size={'small'}>
                <Refresh style={{ color: 'white' }} />
              </IconButton>
            </Tooltip>
            {this.state.fetching && (
              <div className="loading-container" style={{ width: '100%', position: 'absolute', left: 0, top: '44px' }}>
                <LinearProgress className="loading" />
              </div>
            )}
          </AccordionSummary>
          <AccordionDetails style={{ padding: 0, flexDirection: 'column' }}>
            <div className={'container'}>
              <div>Filters:</div>
              <div className={'item'}>
                <FormControlLabel
                  classes={{ label: 'my-label' }}
                  control={
                    <Switch
                      color={'secondary'}
                      checked={this.state.capital}
                      onChange={() =>
                        this.setState({ capital: !this.state.capital }, () => this.refreshUsersCreditCard(false))
                      }
                    />
                  }
                  label={'Capital One'}
                />
              </div>
              <div className={'item'}>
                <FormControlLabel
                  classes={{ label: 'my-label' }}
                  control={
                    <Switch
                      color={'secondary'}
                      checked={this.state.roundupsEnabled}
                      onChange={() =>
                        this.setState({ roundupsEnabled: !this.state.roundupsEnabled }, () =>
                          this.refreshUsersCreditCard(false),
                        )
                      }
                    />
                  }
                  label={'Roundups Enabled'}
                />
              </div>
            </div>
            <TableContainer style={{ maxHeight: 350 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Bank Name</TableCell>
                    <TableCell>Roundups Enabled</TableCell>
                    <TableCell>Needs Reauth since</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.creditCard.map((bank, i) => (
                    <TableRow key={`CreditCard_${i}`}>
                      <TableCell>{bank.user_doc.basic.firstName}</TableCell>
                      <TableCell>{bank.user_doc.basic.lastName}</TableCell>
                      <TableCell>{bank.user_doc.basic.email}</TableCell>
                      <TableCell>{bank.institution.name}</TableCell>
                      <TableCell>{bank.user_doc.settings.roundupsEnabled.toString().toUpperCase()}</TableCell>
                      <TableCell>{moment(bank.reauth).format('MM-DD-YY')}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Paper>
    );
  }
}

ReauthCreditCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(ReauthCreditCard);
